import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
const CLIENT_TOKEN_KEY = 'clientPortalToken';

export const getClientPortalToken = () => localStorage.getItem(CLIENT_TOKEN_KEY);

export const setClientPortalToken = (token) => {
  if (!token) return;
  localStorage.setItem(CLIENT_TOKEN_KEY, token);
};

export const clearClientPortalToken = () => {
  localStorage.removeItem(CLIENT_TOKEN_KEY);
};

const withClientAuth = () => ({
  headers: { Authorization: `Bearer ${getClientPortalToken()}` },
});

export const loginClientPortal = async ({ rut, password }) =>
  (await axios.post(`${API_URL}/client-auth/login`, { rut, password })).data;

export const getClientPortalMe = async () =>
  (await axios.get(`${API_URL}/client-auth/me`, withClientAuth())).data;

export const changeClientPortalPassword = async ({ password, newPassword }) =>
  (await axios.post(`${API_URL}/client-auth/change-password`, { password, newPassword }, withClientAuth())).data;

export const getClientPurchaseOrderCatalog = async () =>
  (await axios.get(`${API_URL}/client-auth/purchase-order-catalog`, withClientAuth())).data;

export const getClientCatalogRealtimeToken = async () =>
  (await axios.get(`${API_URL}/client-auth/catalog-events/token`, withClientAuth())).data;

export const resolveClientCatalogRealtimeWebsocketUrl = (path, token) => {
  const url = new URL(path, API_URL);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  if (token) url.searchParams.set('token', token);
  return url.toString();
};

export const submitClientPurchaseOrder = async ({ items, notes }) =>
  (await axios.post(`${API_URL}/client-auth/purchase-orders`, { items, notes }, withClientAuth())).data;

export const updateClientPurchaseOrder = async (id, { items, notes }) =>
  (await axios.put(`${API_URL}/client-auth/purchase-orders/${id}`, { items, notes }, withClientAuth())).data;

export const listClientPurchaseOrders = async () =>
  (await axios.get(`${API_URL}/client-auth/purchase-orders`, withClientAuth())).data;

export const getClientPurchaseOrderById = async (id) =>
  (await axios.get(`${API_URL}/client-auth/purchase-orders/${id}`, withClientAuth())).data;
